import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetCoverage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path d="M9.835 3.553a6.693 6.693 0 1 0 2.972 12.94l-2.076-3.597a2.693 2.693 0 0 1-.896-5.295zm2.679 8.432 2.044 3.54a6.7 6.7 0 0 0 2.495-4.016h-4.206a2.7 2.7 0 0 1-.333.476m.618-2.27a2.7 2.7 0 0 0-1.504-1.94V3.62a6.696 6.696 0 0 1 5.532 6.096h-4.028Z" />
  </svg>
);
export default SvgAssetCoverage;
